import { classList, createElement, isNullOrUndefined, L10n } from '@syncfusion/ej2-base';
import { NumericTextBox } from '@syncfusion/ej2-inputs';
import { WTableFormat, WBorder, WBorders, WShading, WCellFormat } from '../format/index';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { ColorPicker } from '@syncfusion/ej2-inputs';
/**
 * The Borders and Shading dialog is used to modify borders and shading options for selected table or cells.
 */
var BordersAndShadingDialog = /** @class */ (function () {
    /**
     * @param {DocumentHelper} documentHelper - Specifies the document helper.
     * @private
     */
    function BordersAndShadingDialog(documentHelper) {
        var _this = this;
        this.cellFormat = new WCellFormat();
        this.tableFormat = new WTableFormat();
        this.isShadingChanged = false;
        /**
         * @private
         * @returns {void}
         */
        this.applyBordersShadingsProperties = function () {
            var tablePropertiesDialog = _this.documentHelper.owner.tablePropertiesDialogModule;
            var selectedCell = _this.documentHelper.selection.start.paragraph.associatedCell;
            //Need to bind the properties with current cell and current table formats.
            var borders = undefined;
            if (_this.checkClassName(_this.previewDivTopTop) || _this.checkClassName(_this.previewDivTopBottom)
                || _this.checkClassName(_this.previewDivTopCenter) || _this.checkClassName(_this.previewDivBottomcenter)
                || _this.checkClassName(_this.previewDivBottomLeft) || _this.checkClassName(_this.previewDivBottomRight)
                || _this.checkClassName(_this.previewDivDiagonalRight) || _this.checkClassName(_this.previewDivLeftDiagonal)) {
                borders = new WBorders();
                if (_this.checkClassName(_this.previewDivTopTop)) {
                    borders.top = _this.getBorder('top');
                }
                if (_this.checkClassName(_this.previewDivTopBottom)) {
                    borders.bottom = _this.getBorder('bottom');
                }
                if (_this.checkClassName(_this.previewDivBottomLeft)) {
                    borders.left = _this.getBorder('left');
                }
                if (_this.checkClassName(_this.previewDivBottomRight)) {
                    borders.right = _this.getBorder('right');
                }
                if (_this.checkClassName(_this.previewDivTopCenter)) {
                    borders.horizontal = _this.getBorder('horizontal');
                }
                if (_this.checkClassName(_this.previewDivBottomcenter)) {
                    borders.vertical = _this.getBorder('vertical');
                }
                if (_this.checkClassName(_this.previewDivLeftDiagonal)) {
                    borders.diagonalDown = _this.getBorder('diagonalDown');
                }
                if (_this.checkClassName(_this.previewDivDiagonalRight)) {
                    borders.diagonalUp = _this.getBorder('diagonalUp');
                }
            }
            var shading = new WShading();
            var editorModule = _this.documentHelper.owner.editorModule;
            shading.backgroundColor = _this.shadingColorPicker.value;
            if (_this.ulelementShading.value === 'Cell') {
                if (tablePropertiesDialog) {
                    tablePropertiesDialog.isCellBordersAndShadingUpdated = true;
                }
                _this.cellFormat.borders = new WBorders();
                if (!isNullOrUndefined(borders)) {
                    editorModule.applyBordersInternal(_this.cellFormat.borders, borders);
                }
                else if (_this.noneDiv.classList.contains('e-de-table-border-inside-setting-click')) {
                    editorModule.applyBordersInternal(_this.cellFormat.borders, new WBorders());
                }
                // Once option has been added for texture and foreground, need to handle this similar to Shading Fill.
                if (!isNullOrUndefined(selectedCell.cellFormat.shading)) {
                    shading.foregroundColor = selectedCell.cellFormat.shading.foregroundColor;
                    shading.textureStyle = selectedCell.cellFormat.shading.textureStyle;
                }
                _this.cellFormat.shading = new WShading();
                editorModule.applyShading(_this.cellFormat.shading, shading);
            }
            else if (_this.ulelementShading.value === 'Table') {
                if (tablePropertiesDialog) {
                    tablePropertiesDialog.isTableBordersAndShadingUpdated = true;
                }
                var currentTableFormat = _this.documentHelper.owner.selection.tableFormat.table.tableFormat;
                _this.tableFormat.copyFormat(currentTableFormat);
                _this.tableFormat.borders = new WBorders();
                if (!isNullOrUndefined(borders)) {
                    editorModule.applyBordersInternal(_this.tableFormat.borders, borders);
                }
                else if (_this.noneDiv.classList.contains('e-de-table-border-inside-setting-click')) {
                    editorModule.applyBordersInternal(_this.tableFormat.borders, new WBorders());
                }
                // Once option has been added for texture and foreground, need to handle this similar to Shading Fill.
                if (!isNullOrUndefined(currentTableFormat.shading)) {
                    shading.foregroundColor = currentTableFormat.shading.foregroundColor;
                    shading.textureStyle = currentTableFormat.shading.textureStyle;
                }
                _this.tableFormat.shading = new WShading();
                _this.isShadingChanged = currentTableFormat.shading.backgroundColor !== shading.backgroundColor;
                editorModule.applyShading(_this.tableFormat.shading, shading);
            }
            else if (_this.ulelementShading.value === 'Paragraph') {
                var isNoneBorder = _this.noneDiv.classList.contains('e-de-table-border-inside-setting-click');
                if (!isNullOrUndefined(_this.paragraphFormat)) {
                    editorModule.applyBordersInternal(_this.paragraphFormat.borders, isNoneBorder ? new WBorders() : borders);
                }
                else {
                    editorModule.onApplyParagraphFormat('borders', isNoneBorder ? new WBorders() : borders, false, false);
                }
            }
            _this.applyFormat();
            _this.closeDialog();
        };
        /**
         * @private
         * @returns {void}
         */
        this.closeDialog = function () {
            _this.documentHelper.dialog.hide();
            _this.closeBordersShadingsDialog();
        };
        /**
         * @private
         * @returns {void}
         */
        this.closeBordersShadingsDialog = function () {
            _this.paragraphFormat = undefined;
            _this.documentHelper.dialog2.element.style.pointerEvents = '';
            _this.documentHelper.updateFocus();
        };
        /**
         * @private
         * @param {Event} event - Specifies the event args.
         * @returns {void}
         */
        this.handleSettingCheckBoxAction = function (event) {
            var targetId = event.target.id;
            var tableBorderDialogId = _this.target.id;
            // let targetDiv: HTMLDivElement;
            if (targetId === tableBorderDialogId + '_None_Div' || targetId === tableBorderDialogId + '_None_Div_Container'
                || targetId === tableBorderDialogId + '_None_Div_Transparent') {
                _this.updateClassForSettingDivElements();
                _this.noneDiv.classList.add('e-de-table-border-inside-setting-click');
                _this.setSettingPreviewDivElement('none');
            }
            else if (targetId === tableBorderDialogId + '_Box_Div' || targetId === tableBorderDialogId + '_Box_Div_Container'
                || targetId === tableBorderDialogId + '_Box_Div_Transparent') {
                _this.updateClassForSettingDivElements();
                _this.boxDiv.classList.add('e-de-table-border-inside-setting-click');
                _this.setSettingPreviewDivElement('box');
            }
            else if (targetId === tableBorderDialogId + '_All_Div' || targetId === tableBorderDialogId + '_All_Div_Container'
                || targetId === tableBorderDialogId + '_All_Div_Transparent') {
                _this.updateClassForSettingDivElements();
                _this.allDiv.classList.add('e-de-table-border-inside-setting-click');
                _this.setSettingPreviewDivElement('all');
            }
            else {
                if (_this.ulelementShading.value === 'Paragraph') {
                    _this.updateClassForSettingDivElements();
                    _this.customDiv.classList.add('e-de-table-border-inside-setting-click');
                    _this.setSettingPreviewDivElement('customDiv');
                }
                else {
                    _this.updateClassForSettingDivElements();
                    _this.customDiv.classList.add('e-de-table-border-inside-setting-click');
                    _this.setSettingPreviewDivElement('customDiv');
                }
            }
        };
        /**
         * @private
         * @param {Event} event - Specifies the event args.
         * @returns {void}
         */
        this.handlePreviewCheckBoxAction = function (event) {
            var target = event.target;
            var targetId = target.id;
            // const tableBorderDialog: HTMLElement = this.target;
            var tableBorderDialogId = _this.target.id;
            var compareClass = 'e-de-table-border-inside-preview-click';
            _this.customDiv.click();
            if (targetId === tableBorderDialogId + '_Preview_Div_TopTop_Container' || targetId === tableBorderDialogId + '_Preview_Div_TopTop'
                || targetId === tableBorderDialogId + '_previewDivTopTopTransParent') {
                _this.handlePreviewCheckBoxShowHide(tableBorderDialogId, compareClass, _this.previewDivTopTop);
                _this.showHidePreviewDivElements(tableBorderDialogId, compareClass, '_Preview_Div', '_Preview_Div_TopTop', 'TopTop');
            }
            else if (targetId === tableBorderDialogId + '_Preview_Div_TopCenter_Container'
                || targetId === tableBorderDialogId + '_Preview_Div_TopCenter'
                || targetId === tableBorderDialogId + '_previewDivTopCenterTransParent') {
                _this.handlePreviewCheckBoxShowHide(tableBorderDialogId, compareClass, _this.previewDivTopCenter);
                _this.showHidePreviewDivElements(tableBorderDialogId, compareClass, '_Preview_Div_Horizontal', '_Preview_Div_TopCenter', 'TopCenter');
            }
            else if (targetId === tableBorderDialogId + '_Preview_Div_TopBottom_Container' || targetId === tableBorderDialogId + '_Preview_Div_TopBottom'
                || targetId === tableBorderDialogId + '_previewDivTopBottomTransParent') {
                _this.handlePreviewCheckBoxShowHide(tableBorderDialogId, compareClass, _this.previewDivTopBottom);
                _this.showHidePreviewDivElements(tableBorderDialogId, compareClass, '_Preview_Div', '_Preview_Div_TopBottom', 'TopBottom');
            }
            else if (targetId === tableBorderDialogId + '_Preview_Div_LeftDiagonal_Container'
                || targetId === tableBorderDialogId + '_Preview_Div_LeftDiagonal'
                || targetId === tableBorderDialogId + '_previewDivLeftDiagonalTransParent') {
                _this.handlePreviewCheckBoxShowHide(tableBorderDialogId, compareClass, _this.previewDivLeftDiagonal);
                _this.showHidePreviewDivElements(tableBorderDialogId, compareClass, '_Preview_Div_Left_Diagonal', '_Preview_Div_LeftDiagonal', 'LeftDiagonal');
            }
            else if (targetId === tableBorderDialogId + '_Preview_Div_BottomLeft_Container' || targetId === tableBorderDialogId + '_Preview_Div_BottomLeft'
                || targetId === tableBorderDialogId + '_previewDivBottomLeftTransparent') {
                _this.handlePreviewCheckBoxShowHide(tableBorderDialogId, compareClass, _this.previewDivBottomLeft);
                _this.showHidePreviewDivElements(tableBorderDialogId, compareClass, '_Preview_Div', '_Preview_Div_BottomLeft', 'BottomLeft');
            }
            else if (targetId === tableBorderDialogId + '_Preview_Div_BottomCenter_Container'
                || targetId === tableBorderDialogId + '_Preview_Div_BottomCenter'
                || targetId === tableBorderDialogId + '_previewDivBottomcenterTransparent') {
                _this.handlePreviewCheckBoxShowHide(tableBorderDialogId, compareClass, _this.previewDivBottomcenter);
                _this.showHidePreviewDivElements(tableBorderDialogId, compareClass, '_Preview_Div_Vertical', '_Preview_Div_BottomCenter', 'BottomCenter');
            }
            else if (targetId === tableBorderDialogId + '_Preview_Div_BottomRight_Container' || targetId === tableBorderDialogId + '_Preview_Div_BottomRight'
                || targetId === tableBorderDialogId + '_previewDivBottomRightTransparent') {
                _this.handlePreviewCheckBoxShowHide(tableBorderDialogId, compareClass, _this.previewDivBottomRight);
                _this.showHidePreviewDivElements(tableBorderDialogId, compareClass, '_Preview_Div', '_Preview_Div_BottomRight', 'BottomRight');
            }
            else if (targetId === tableBorderDialogId + '_Preview_Div_RightDiagonal_Container'
                || targetId === tableBorderDialogId + '_Preview_Div_RightDiagonal'
                || targetId === tableBorderDialogId + '_previewDivDiagonalRightTransparent') {
                _this.handlePreviewCheckBoxShowHide(tableBorderDialogId, compareClass, _this.previewDivDiagonalRight);
                _this.showHidePreviewDivElements(tableBorderDialogId, compareClass, '_Preview_Div_Right_Diagonal', '_Preview_Div_RightDiagonal', 'RightDiagonal');
            }
        };
        /**
         * @private
         * @returns {void}
         */
        this.applyTableCellPreviewBoxes = function () {
            //this.customDiv.click();
            if (!isNullOrUndefined(_this.ulelementShading)) {
                if (_this.ulelementShading.value === 'Cell') {
                    _this.shadingColorPicker.disabled = false;
                    _this.previewDivBottomcenterContainer.style.visibility = 'hidden';
                    _this.previewDivTopCenterContainer.style.visibility = 'hidden';
                    _this.previewVerticalDiv.style.display = 'none';
                    _this.previewHorizontalDiv.style.display = 'none';
                    _this.previewDivLeftDiagonal.style.display = '';
                    _this.previewDivDiagonalRight.style.display = '';
                    _this.previewDivBottomRightContainer.style.left = '80px';
                    classList(_this.noneDivTransparent, ['e-de-table-border-none-setting'], ['e-de-para-border-none-setting']);
                    classList(_this.boxDivTransparent, ['e-de-table-border-box-setting'], ['e-de-para-border-box-setting']);
                    classList(_this.allDivTransparent, ['e-de-table-border-all-setting'], ['e-de-para-border-shadow-setting']);
                    classList(_this.customDivTransparent, ['e-de-table-border-custom-setting'], ['e-de-para-border-custom-setting']);
                }
                else if (_this.ulelementShading.value === 'Table') {
                    _this.shadingColorPicker.disabled = false;
                    _this.previewDivLeftDiagonal.style.display = 'none';
                    _this.previewDivDiagonalRight.style.display = 'none';
                    _this.previewDivBottomcenterContainer.style.visibility = 'visible';
                    _this.previewDivTopCenterContainer.style.visibility = 'visible';
                    _this.previewVerticalDiv.style.display = '';
                    _this.previewHorizontalDiv.style.display = '';
                    _this.previewDivBottomRightContainer.style.left = '110px';
                    classList(_this.noneDivTransparent, ['e-de-table-border-none-setting'], ['e-de-para-border-none-setting']);
                    classList(_this.boxDivTransparent, ['e-de-table-border-box-setting'], ['e-de-para-border-box-setting']);
                    classList(_this.allDivTransparent, ['e-de-table-border-all-setting'], ['e-de-para-border-shadow-setting']);
                    classList(_this.customDivTransparent, ['e-de-table-border-custom-setting'], ['e-de-para-border-custom-setting']);
                }
                else {
                    _this.shadingColorPicker.disabled = true;
                    _this.previewDivBottomcenterContainer.style.visibility = 'hidden';
                    _this.previewDivTopCenterContainer.style.visibility = 'hidden';
                    _this.previewVerticalDiv.style.display = 'none';
                    _this.previewHorizontalDiv.style.display = 'none';
                    _this.previewLeftDiagonalDiv.style.display = 'none';
                    _this.previewRightDiagonalDiv.style.display = 'none';
                    classList(_this.noneDivTransparent, ['e-de-para-border-none-setting'], ['e-de-table-border-none-setting']);
                    classList(_this.boxDivTransparent, ['e-de-para-border-box-setting'], ['e-de-table-border-box-setting']);
                    classList(_this.allDivTransparent, ['e-de-para-border-shadow-setting'], ['e-de-table-border-all-setting']);
                    classList(_this.customDivTransparent, ['e-de-para-border-custom-setting'], ['e-de-table-border-custom-setting']);
                }
            }
        };
        /**
         * @private
         * @param {ColorPickerEventArgs} args - Specifies the event args.
         * @returns {void}
         */
        this.applyPreviewTableBackgroundColor = function (args) {
            if (!isNullOrUndefined(args.currentValue)) {
                var color = args.currentValue.hex;
                _this.previewDiv.style.backgroundColor = color;
            }
        };
        /**
         * @private
         * @param {ColorPickerEventArgs} args - Specifies the event args.
         * @returns {void}
         */
        this.applyPreviewTableBorderColor = function (args) {
            if (!isNullOrUndefined(args.currentValue)) {
                var color = args.currentValue.hex;
                _this.previewDiv.style.borderColor = color;
                _this.previewRightDiagonalDiv.style.backgroundColor = color;
                _this.previewLeftDiagonalDiv.style.backgroundColor = color;
                _this.previewVerticalDiv.style.backgroundColor = color;
                _this.previewHorizontalDiv.style.backgroundColor = color;
            }
        };
        this.documentHelper = documentHelper;
    }
    BordersAndShadingDialog.prototype.getModuleName = function () {
        return 'BordersAndShadingDialog';
    };
    /**
     * @private
     * @param {L10n} localeValue - Specifies the locale.
     * @param {boolean} isRtl - Specifies is rtl.
     * @returns {void}
     */
    BordersAndShadingDialog.prototype.initBordersAndShadingsDialog = function (localeValue, isRtl) {
        this.target = createElement('div', {
            id: this.documentHelper.owner.containerId + '_table_border_shadings',
            className: 'e-de-table-border-shading-dlg'
        });
        var displayText = createElement('div', {
            innerHTML: localeValue.getConstant('Borders'),
            className: 'e-de-table-border-heading'
        });
        var settingAndPreviewContainer = createElement('div', {
            className: 'e-de-dlg-row'
        });
        var settingsContiner = createElement('div', {});
        var styleContainer = createElement('div', {});
        var previewContiner = createElement('div', {
            className: 'e-de-table-border-preview-container'
        });
        var previewSubContainer1 = createElement('div', {
            className: 'e-de-dlg-row'
        });
        var previewSubContainer2 = createElement('div', {});
        var styleSubContainer = createElement('div', {
            className: 'e-de-container-row'
        });
        var dropdownListDiv = createElement('div', {
            className: 'e-de-subcontainer-left'
        });
        var dropDownList = createElement('select', {});
        dropDownList.innerHTML = '<option value="None">' + localeValue.getConstant('None') + '</option><option value="Single">'
            + localeValue.getConstant('Single') + '</option><option value="Dot">' + localeValue.getConstant('Dot') + '</option><option value="DashSmallGap">'
            + localeValue.getConstant('DashSmallGap') + '</option><option value="DashLargeGap">' + localeValue.getConstant('DashLargeGap') + '</option><option value="DashDot">'
            + localeValue.getConstant('DashDot') + '</option><option value="DashDotDot">' + localeValue.getConstant('DashDotDot') + '</option><option value="Double">'
            + localeValue.getConstant('Double') + '</option><option value="Triple">' + localeValue.getConstant('Triple') + '</option><option value="ThinThickSmallGap">'
            + localeValue.getConstant('ThinThickSmallGap') + '</option><option value="ThickThinSmallGap">'
            + localeValue.getConstant('ThickThinSmallGap') + '</option><option value="ThinThickThinSmallGap">' + localeValue.getConstant('ThinThickThinSmallGap')
            + '</option><option value="ThinThickMediumGap">' + localeValue.getConstant('ThinThickMediumGap') + '</option><option value="ThickThinMediumGap">'
            + localeValue.getConstant('ThickThinMediumGap') + '</option><option value="ThinThickThinMediumGap">' + localeValue.getConstant('ThinThickThinMediumGap')
            + '</option><option value="ThinThickLargeGap">' + localeValue.getConstant('ThinThickLargeGap') + '</option><option value="ThickThinLargeGap">'
            + localeValue.getConstant('ThickThinLargeGap') + '</option><option value="ThinThickThinLargeGap">' + localeValue.getConstant('ThinThickThinLargeGap')
            + '</option><option value="SingleWavy">' + localeValue.getConstant('SingleWavy') + '</option><option value="DoubleWavy">'
            + localeValue.getConstant('DoubleWavy') + '</option><option value="DashDotStroked">' + localeValue.getConstant('DashDotStroked')
            + '</option><option value="Emboss3D">' + localeValue.getConstant('Emboss3D') + '</option><option value="Engrave3D">' + localeValue.getConstant('Engrave3D')
            + '</option><option value="Outset">' + localeValue.getConstant('Outset') + '</option><option value="Inset">'
            + localeValue.getConstant('Inset') + '</option><option value="Thick">' + localeValue.getConstant('Thick') + '</option>';
        var widthcontainerDiv = createElement('div', {
            className: 'e-de-container-row'
        });
        var widthNumericDiv = createElement('div', {
            className: 'e-de-subcontainer-left'
        });
        var widthNumeric = createElement('input', {});
        var colorDiv = createElement('div', {
            className: 'e-de-subcontainer-right'
        });
        var colorText = createElement('div', {
            innerHTML: localeValue.getConstant('Color'),
            className: 'e-de-table-border-clr-heading'
        });
        var borderColorPickerElement = createElement('input', {
            attrs: { 'type': 'color' },
            className: 'e-dlg-clr-pkr-top'
        });
        var settingText = createElement('div', {
            innerHTML: localeValue.getConstant('Setting'),
            className: 'e-de-table-setting-heading'
        });
        var settingsSubContiner = createElement('div', {
            className: 'e-de-dlg-row'
        });
        var noneDivContainer = createElement('div', {
            id: this.target.id + '_None_Div_Container',
        });
        this.noneDiv = createElement('div', {
            id: this.target.id + '_None_Div',
            className: 'e-de-table-border-inside-setting e-de-table-border-setting-genral'
        });
        var noneDivLabel = createElement('label', {
            innerHTML: localeValue.getConstant('None'), className: 'e-de-table-setting-labels-heading',
            id: this.target.id + '_None_Div_Label'
        });
        var boxDivContainer = createElement('div', {
            id: this.target.id + '_Box_Div_Container',
        });
        this.boxDiv = createElement('div', {
            id: this.target.id + '_Box_Div',
            className: 'e-de-table-border-inside-setting e-de-table-border-setting-genral'
        });
        var boxDivLabel = createElement('label', {
            innerHTML: localeValue.getConstant('Box'), className: 'e-de-table-setting-labels-heading',
            id: this.target.id + '_Box_Div_Label'
        });
        var allDivContainer = createElement('div', {
            id: this.target.id + '_All_Div_Container',
        });
        this.allDiv = createElement('div', {
            id: this.target.id + '_All_Div',
            className: 'e-de-table-border-inside-setting e-de-table-border-setting-genral'
        });
        var allDivLabel = createElement('label', {
            innerHTML: localeValue.getConstant('All'), className: 'e-de-table-setting-labels-heading',
            id: this.target.id + '_All_Div_Label'
        });
        var customDivContainer = createElement('div', {
            id: this.target.id + '_Custom_Div_Container',
        });
        this.customDiv = createElement('div', {
            id: this.target.id + '_Custom_Div',
            className: 'e-de-table-border-inside-setting e-de-table-border-setting-genral'
        });
        var customDivLabel = createElement('label', {
            innerHTML: localeValue.getConstant('Custom'), className: 'e-de-table-setting-labels-heading',
            id: this.target.id + '_Custom_Div_Label'
        });
        this.noneDivTransparent = createElement('div', {
            id: this.target.id + '_None_Div_Transparent', className: 'e-icons e-de-table-border-setting e-de-table-border-none-setting'
        });
        this.boxDivTransparent = createElement('div', {
            id: this.target.id + '_Box_Div_Transparent', className: 'e-icons e-de-table-border-setting e-de-table-border-box-setting'
        });
        this.allDivTransparent = createElement('div', {
            id: this.target.id + '_All_Div_Transparent', className: 'e-icons e-de-table-border-setting e-de-table-border-all-setting'
        });
        this.customDivTransparent = createElement('div', {
            id: this.target.id + '_Custom_Div_Transparent', className: 'e-icons e-de-table-border-setting e-de-table-border-custom-setting'
        });
        if (isRtl) {
            this.noneDivTransparent.classList.add('e-de-rtl');
            this.boxDivTransparent.classList.add('e-de-rtl');
            this.allDivTransparent.classList.add('e-de-rtl');
            this.customDivTransparent.classList.add('e-de-rtl');
        }
        var previewText = createElement('div', {
            innerHTML: localeValue.getConstant('Preview'), className: 'e-de-table-setting-heading',
        });
        this.previewDiv = createElement('div', {
            id: this.target.id + '_Preview_Div', className: 'e-de-border-dlg-preview-div',
            styles: 'position: relative'
        });
        this.previewRightDiagonalDiv = createElement('div', {
            styles: 'position: absolute;width:1px;height:111px;left: 38px;top: -17px;transform: rotate(135deg); background-color: black',
            id: this.target.id + '_Preview_Div_Right_Diagonal',
            className: 'e-de-border-dlg-preview-inside-divs'
        });
        this.previewLeftDiagonalDiv = createElement('div', {
            styles: 'position: absolute;width: 1px;height: 111px;left: 38px;top: -17px;transform:rotate(45deg); background-color: black',
            id: this.target.id + '_Preview_Div_Left_Diagonal',
            className: 'e-de-border-dlg-preview-inside-divs'
        });
        this.previewVerticalDiv = createElement('div', {
            styles: 'width: 1px;height: 80px;position: absolute;left: 39px;top: -1px; background-color: black',
            id: this.target.id + '_Preview_Div_Vertical',
            className: 'e-de-border-dlg-preview-inside-divs'
        });
        this.previewHorizontalDiv = createElement('div', {
            styles: 'width: 80px;height: 1px;position: absolute;left: -1px;top: 41px; background-color: black',
            id: this.target.id + '_Preview_Div_Horizontal',
            className: 'e-de-border-dlg-preview-inside-divs'
        });
        var previewDivVerticalContainer = createElement('div');
        this.previewDivTopTopContainer = createElement('div', {
            styles: 'margin-top: 0',
            className: 'e-de-table-border-icon-container',
            id: this.target.id + '_Preview_Div_TopTop_Container'
        });
        this.previewDivTopTop = createElement('div', {
            id: this.target.id + '_Preview_Div_TopTop',
            className: 'e-de-table-border-inside-preview e-de-table-border-preview-genral'
        });
        this.previewDivTopCenterContainer = createElement('div', {
            className: 'e-de-table-border-icon-container',
            id: this.target.id + '_Preview_Div_TopCenter_Container'
        });
        this.previewDivTopCenter = createElement('div', {
            id: this.target.id + '_Preview_Div_TopCenter',
            className: 'e-de-table-border-inside-preview e-de-table-border-preview-genral'
        });
        this.previewDivTopBottomContainer = createElement('div', {
            className: 'e-de-table-border-icon-container',
            id: this.target.id + '_Preview_Div_TopBottom_Container'
        });
        this.previewDivTopBottom = createElement('div', {
            id: this.target.id + '_Preview_Div_TopBottom',
            className: 'e-de-table-border-inside-preview e-de-table-border-preview-genral'
        });
        this.previewDivLeftDiagonalContainer = createElement('div', {
            className: 'e-de-table-border-icon-container',
            id: this.target.id + '_Preview_Div_LeftDiagonal_Container'
        });
        this.previewDivLeftDiagonal = createElement('div', {
            id: this.target.id + '_Preview_Div_LeftDiagonal',
            className: 'e-de-table-border-inside-preview e-de-table-border-preview-genral'
        });
        var previewDivHorizontalContainer = createElement('div', { className: 'e-de-dlg-row' });
        this.previewDivBottomLeftContainer = createElement('div', {
            id: this.target.id + '_Preview_Div_BottomLeft_Container',
            className: 'e-de-table-border-icon-container'
        });
        this.previewDivBottomLeft = createElement('div', {
            id: this.target.id + '_Preview_Div_BottomLeft',
            className: 'e-de-table-border-inside-preview e-de-table-border-preview-genral'
        });
        this.previewDivBottomcenterContainer = createElement('div', {
            id: this.target.id + '_Preview_Div_BottomCenter_Container',
            className: 'e-de-table-border-icon-container'
        });
        this.previewDivBottomcenter = createElement('div', {
            id: this.target.id + '_Preview_Div_BottomCenter',
            className: 'e-de-table-border-inside-preview e-de-table-border-preview-genral'
        });
        this.previewDivBottomRightContainer = createElement('div', {
            id: this.target.id + '_Preview_Div_BottomRight_Container',
            className: 'e-de-table-border-icon-container'
        });
        this.previewDivBottomRight = createElement('div', {
            id: this.target.id + '_Preview_Div_BottomRight',
            className: 'e-de-table-border-inside-preview e-de-table-border-preview-genral'
        });
        this.previewDivDiagonalRightContainer = createElement('div', {
            className: 'e-de-table-border-icon-container',
            id: this.target.id + '_Preview_Div_RightDiagonal_Container'
        });
        this.previewDivDiagonalRight = createElement('div', {
            id: this.target.id + '_Preview_Div_RightDiagonal',
            className: 'e-de-table-border-inside-preview e-de-table-border-preview-genral'
        });
        this.previewDivTopTopTransParent = createElement('div', {
            id: this.target.id + '_previewDivTopTopTransParent',
            className: 'e-icons e-de-table-border-preview e-de-table-border-toptop-alignment'
        });
        this.previewDivTopCenterTransParent = createElement('div', {
            id: this.target.id + '_previewDivTopCenterTransParent',
            className: 'e-icons e-de-table-border-preview e-de-table-border-topcenter-alignment'
        });
        this.previewDivTopBottomTransParent = createElement('div', {
            id: this.target.id + '_previewDivTopBottomTransParent',
            className: 'e-icons e-de-table-border-preview e-de-table-border-topbottom-alignment'
        });
        this.previewDivLeftDiagonalTransParent = createElement('div', {
            id: this.target.id + '_previewDivLeftDiagonalTransParent',
            className: 'e-icons e-de-table-border-preview e-de-table-border-diagionalup-alignment'
        });
        this.previewDivBottomLeftTransparent = createElement('div', {
            id: this.target.id + '_previewDivBottomLeftTransparent',
            className: 'e-icons e-de-table-border-preview e-de-table-border-bottomleft-alignment'
        });
        this.previewDivBottomcenterTransparent = createElement('div', {
            id: this.target.id + '_previewDivBottomcenterTransparent',
            className: 'e-icons e-de-table-border-preview e-de-table-border-bottomcenter-alignment'
        });
        this.previewDivBottomRightTransparent = createElement('div', {
            id: this.target.id + '_previewDivBottomRightTransparent',
            className: 'e-icons e-de-table-border-preview e-de-table-border-bottomright-alignment'
        });
        this.previewDivDiagonalRightTransparent = createElement('div', {
            id: this.target.id + '_previewDivDiagonalRightTransparent',
            className: 'e-icons e-de-table-border-preview e-de-table-border-diagionaldown-alignment'
        });
        this.shadingContiner = createElement('div', {});
        var shadingText = createElement('div', {
            innerHTML: localeValue.getConstant('Shading'), className: 'e-de-table-border-heading',
        });
        var shadings = createElement('div', { className: 'e-de-dlg-row' });
        var colorPickerDiv = createElement('div', { className: 'e-de-table-border-clr-left-container' });
        var label = createElement('div', {
            innerHTML: localeValue.getConstant('Fill'), className: 'e-de-table-border-clr-heading',
        });
        var shadingColorPickerElement = createElement('input', {
            attrs: { 'type': 'color' },
            id: this.target.id + '_shading_color',
        });
        var shdApply = createElement('div', {
            className: 'e-de-subcontainer-right'
        });
        var ulelementShading = createElement('input', {
            id: this.target.id + '_shading'
        });
        var ulelementShadingValue = [
            { Value: 'Cell', Name: localeValue.getConstant('Cell ') },
            { Value: 'Table', Name: localeValue.getConstant('Table') },
            { Value: 'Paragraph', Name: localeValue.getConstant('Paragraph') }
        ];
        shdApply.appendChild(ulelementShading);
        this.noneDiv.appendChild(this.noneDivTransparent);
        this.boxDiv.appendChild(this.boxDivTransparent);
        this.allDiv.appendChild(this.allDivTransparent);
        this.customDiv.appendChild(this.customDivTransparent);
        noneDivContainer.appendChild(this.noneDiv);
        noneDivContainer.appendChild(noneDivLabel);
        boxDivContainer.appendChild(this.boxDiv);
        boxDivContainer.appendChild(boxDivLabel);
        allDivContainer.appendChild(this.allDiv);
        allDivContainer.appendChild(allDivLabel);
        customDivContainer.appendChild(this.customDiv);
        customDivContainer.appendChild(customDivLabel);
        settingsContiner.appendChild(settingText);
        settingsContiner.appendChild(settingsSubContiner);
        settingsSubContiner.appendChild(noneDivContainer);
        settingsSubContiner.appendChild(boxDivContainer);
        settingsSubContiner.appendChild(allDivContainer);
        settingsSubContiner.appendChild(customDivContainer);
        this.previewDivBottomcenter.appendChild(this.previewDivBottomcenterTransparent);
        this.previewDivBottomRight.appendChild(this.previewDivBottomRightTransparent);
        this.previewDivBottomLeft.appendChild(this.previewDivBottomLeftTransparent);
        this.previewDivTopTop.appendChild(this.previewDivTopTopTransParent);
        this.previewDivTopCenter.appendChild(this.previewDivTopCenterTransParent);
        this.previewDivTopBottom.appendChild(this.previewDivTopBottomTransParent);
        this.previewDivDiagonalRight.appendChild(this.previewDivDiagonalRightTransparent);
        this.previewDivLeftDiagonal.appendChild(this.previewDivLeftDiagonalTransParent);
        this.previewDivBottomcenterContainer.appendChild(this.previewDivBottomcenter);
        this.previewDivBottomLeftContainer.appendChild(this.previewDivBottomLeft);
        this.previewDivBottomRightContainer.appendChild(this.previewDivBottomRight);
        this.previewDivDiagonalRightContainer.appendChild(this.previewDivDiagonalRight);
        this.previewDivLeftDiagonalContainer.appendChild(this.previewDivLeftDiagonal);
        this.previewDivTopBottomContainer.appendChild(this.previewDivTopBottom);
        this.previewDivTopCenterContainer.appendChild(this.previewDivTopCenter);
        this.previewDivTopTopContainer.appendChild(this.previewDivTopTop);
        previewContiner.appendChild(previewText);
        previewContiner.appendChild(previewSubContainer1);
        previewSubContainer1.appendChild(previewDivVerticalContainer);
        previewSubContainer1.appendChild(previewSubContainer2);
        previewSubContainer2.appendChild(this.previewDiv);
        previewSubContainer2.appendChild(previewDivHorizontalContainer);
        this.previewDiv.appendChild(this.previewLeftDiagonalDiv);
        this.previewDiv.appendChild(this.previewRightDiagonalDiv);
        this.previewDiv.appendChild(this.previewHorizontalDiv);
        this.previewDiv.appendChild(this.previewVerticalDiv);
        previewDivHorizontalContainer.appendChild(this.previewDivBottomLeftContainer);
        previewDivHorizontalContainer.appendChild(this.previewDivBottomcenterContainer);
        previewDivHorizontalContainer.appendChild(this.previewDivBottomRightContainer);
        previewDivHorizontalContainer.appendChild(this.previewDivDiagonalRightContainer);
        previewDivVerticalContainer.appendChild(this.previewDivTopTopContainer);
        previewDivVerticalContainer.appendChild(this.previewDivTopCenterContainer);
        previewDivVerticalContainer.appendChild(this.previewDivTopBottomContainer);
        previewDivVerticalContainer.appendChild(this.previewDivLeftDiagonalContainer);
        shadings.appendChild(colorPickerDiv);
        colorPickerDiv.appendChild(label);
        colorPickerDiv.appendChild(shadingColorPickerElement);
        shadings.appendChild(shdApply);
        this.shadingContiner.appendChild(shadingText);
        this.shadingContiner.appendChild(shadings);
        styleContainer.appendChild(styleSubContainer);
        styleSubContainer.appendChild(dropdownListDiv);
        dropdownListDiv.appendChild(dropDownList);
        styleContainer.appendChild(widthcontainerDiv);
        widthcontainerDiv.appendChild(widthNumericDiv);
        widthNumericDiv.appendChild(widthNumeric);
        widthcontainerDiv.appendChild(colorDiv);
        colorDiv.appendChild(colorText);
        colorDiv.appendChild(borderColorPickerElement);
        borderColorPickerElement.setAttribute('aria-label', colorText.innerHTML);
        settingAndPreviewContainer.appendChild(settingsContiner);
        settingAndPreviewContainer.appendChild(previewContiner);
        this.target.appendChild(displayText);
        this.target.appendChild(settingAndPreviewContainer);
        this.target.appendChild(styleContainer);
        this.target.appendChild(this.shadingContiner);
        // Handling Setting Container
        noneDivContainer.addEventListener('click', this.handleSettingCheckBoxAction);
        boxDivContainer.addEventListener('click', this.handleSettingCheckBoxAction);
        allDivContainer.addEventListener('click', this.handleSettingCheckBoxAction);
        customDivContainer.addEventListener('click', this.handleSettingCheckBoxAction);
        // Handling Preview Div Container
        this.previewDivBottomcenterContainer.addEventListener('click', this.handlePreviewCheckBoxAction);
        this.previewDivBottomLeftContainer.addEventListener('click', this.handlePreviewCheckBoxAction);
        this.previewDivBottomRightContainer.addEventListener('click', this.handlePreviewCheckBoxAction);
        this.previewDivTopTopContainer.addEventListener('click', this.handlePreviewCheckBoxAction);
        this.previewDivTopBottomContainer.addEventListener('click', this.handlePreviewCheckBoxAction);
        this.previewDivTopCenterContainer.addEventListener('click', this.handlePreviewCheckBoxAction);
        this.previewDivDiagonalRightContainer.addEventListener('click', this.handlePreviewCheckBoxAction);
        this.previewDivLeftDiagonalContainer.addEventListener('click', this.handlePreviewCheckBoxAction);
        // handling dropdown change
        this.borderWidth = new NumericTextBox({
            value: 0, min: 0, max: 6, decimals: 2,
            floatLabelType: 'Always', placeholder: localeValue.getConstant('Width'),
            enablePersistence: false
        });
        this.borderWidth.appendTo(widthNumeric);
        widthNumeric.setAttribute('aria-labelledby', localeValue.getConstant('width'));
        this.borderStyle = new DropDownList({
            popupHeight: '150px', index: 1,
            floatLabelType: 'Always', placeholder: localeValue.getConstant('Style'),
            enableRtl: isRtl
        });
        this.borderStyle.appendTo(dropDownList);
        dropDownList.setAttribute('aria-lablledby', localeValue.getConstant('Style'));
        this.ulelementShading = new DropDownList({
            dataSource: ulelementShadingValue,
            fields: { text: 'Name', value: 'Value' },
            change: this.applyTableCellPreviewBoxes, index: 1,
            floatLabelType: 'Always', placeholder: localeValue.getConstant('Apply To'),
            enableRtl: isRtl,
            htmlAttributes: { 'aria-labelledby': localeValue.getConstant('Apply To') }
        });
        this.ulelementShading.appendTo(ulelementShading);
        this.borderColorPicker = new ColorPicker({
            value: '#000000', change: this.applyPreviewTableBorderColor,
            enableRtl: isRtl, locale: this.documentHelper.owner.locale, cssClass: 'e-de-dlg-clr-picker',
            enableOpacity: false
        });
        this.borderColorPicker.appendTo(borderColorPickerElement);
        this.shadingColorPicker = new ColorPicker({
            value: '#FFFFFF', change: this.applyPreviewTableBackgroundColor,
            enableRtl: isRtl, locale: this.documentHelper.owner.locale, cssClass: 'e-de-dlg-clr-picker',
            enableOpacity: false
        });
        this.shadingColorPicker.appendTo(shadingColorPickerElement);
        if (isRtl) {
            label.classList.add('e-de-rtl');
        }
    };
    BordersAndShadingDialog.prototype.applyFormat = function () {
        // const selection: Selection = this.documentHelper.selection;
        var editorModule = this.documentHelper.owner.editorModule;
        if (this.ulelementShading.value !== 'Paragraph') {
            editorModule.initComplexHistory('BordersAndShading');
            editorModule.isBordersAndShadingDialog = true;
            if (this.ulelementShading.value === 'Cell') {
                editorModule.onCellFormat(this.cellFormat);
            }
            else if (this.ulelementShading.value === 'Table') {
                editorModule.onTableFormat(this.tableFormat, this.isShadingChanged);
            }
            if (!isNullOrUndefined(this.documentHelper.owner.editorHistory.currentHistoryInfo)) {
                this.documentHelper.owner.editorHistory.updateComplexHistory();
            }
        }
        editorModule.isBordersAndShadingDialog = false;
    };
    BordersAndShadingDialog.prototype.getBorder = function (type) {
        var border = new WBorder();
        border.color = this.borderColorPicker.value;
        border.lineStyle = this.borderStyle.text;
        border.lineWidth = this.borderWidth.value;
        if (type === 'left' || type === 'right') {
            border.space = 4;
        }
        else {
            border.space = 1;
        }
        return border;
    };
    BordersAndShadingDialog.prototype.checkClassName = function (element) {
        return element.classList.contains('e-de-table-border-inside-preview-click');
    };
    /**
     * @private
     * @returns {void}
     */
    BordersAndShadingDialog.prototype.show = function () {
        var localeValue = new L10n('documenteditor', this.documentHelper.owner.defaultLocale);
        localeValue.setLocale(this.documentHelper.owner.locale);
        if (!this.target) {
            this.initBordersAndShadingsDialog(localeValue, this.documentHelper.owner.enableRtl);
        }
        this.loadBordersShadingsPropertiesDialog(localeValue);
        this.documentHelper.dialog.content = this.target;
        this.documentHelper.dialog.header = localeValue.getConstant('Borders and Shading');
        this.documentHelper.dialog.beforeOpen = this.documentHelper.updateFocus;
        this.documentHelper.dialog.close = this.closeBordersShadingsDialog;
        this.documentHelper.dialog.position = { X: 'center', Y: 'center' };
        this.documentHelper.dialog.width = 'auto';
        this.documentHelper.dialog.height = 'auto';
        this.documentHelper.dialog.buttons = [{
                click: this.applyBordersShadingsProperties,
                buttonModel: { content: localeValue.getConstant('Ok'), cssClass: 'e-flat e-table-border-shading-okay', isPrimary: true }
            },
            {
                click: this.closeDialog,
                buttonModel: { content: localeValue.getConstant('Cancel'), cssClass: 'e-flat e-table-border-shading-cancel' }
            }];
        this.documentHelper.dialog.dataBind();
        this.documentHelper.dialog.show();
    };
    BordersAndShadingDialog.prototype.updateClassForSettingDivElements = function () {
        var settingDivs = this.target.getElementsByClassName('e-de-table-border-inside-setting');
        for (var j = 0; j < settingDivs.length; j++) {
            if (settingDivs[parseInt(j.toString(), 10)].className.indexOf('e-de-table-border-inside-setting-click') !== -1) {
                var tempClassName = settingDivs[parseInt(j.toString(), 10)].className;
                tempClassName = tempClassName.replace('e-de-table-border-inside-setting-click', '');
                settingDivs[parseInt(j.toString(), 10)].className = tempClassName;
            }
        }
    };
    BordersAndShadingDialog.prototype.setSettingPreviewDivElement = function (position) {
        switch (position) {
            case 'none':
                this.previewDivTopTop.classList.remove('e-de-table-border-inside-preview-click');
                this.previewDivTopCenter.classList.remove('e-de-table-border-inside-preview-click');
                this.previewDivTopBottom.classList.remove('e-de-table-border-inside-preview-click');
                this.previewDivLeftDiagonal.classList.remove('e-de-table-border-inside-preview-click');
                this.previewDivDiagonalRight.classList.remove('e-de-table-border-inside-preview-click');
                this.previewDivBottomRight.classList.remove('e-de-table-border-inside-preview-click');
                this.previewDivBottomLeft.classList.remove('e-de-table-border-inside-preview-click');
                this.previewDivBottomcenter.classList.remove('e-de-table-border-inside-preview-click');
                this.isShowHidePreviewTableElements('none');
                break;
            case 'box':
                this.previewDivTopCenter.classList.remove('e-de-table-border-inside-preview-click');
                this.previewDivLeftDiagonal.classList.remove('e-de-table-border-inside-preview-click');
                this.previewDivDiagonalRight.classList.remove('e-de-table-border-inside-preview-click');
                this.previewDivBottomcenter.classList.remove('e-de-table-border-inside-preview-click');
                this.previewDivTopTop.classList.add('e-de-table-border-inside-preview-click');
                this.previewDivTopBottom.classList.add('e-de-table-border-inside-preview-click');
                this.previewDivBottomRight.classList.add('e-de-table-border-inside-preview-click');
                this.previewDivBottomLeft.classList.add('e-de-table-border-inside-preview-click');
                this.isShowHidePreviewTableElements('box');
                break;
            case 'all':
                if (this.ulelementShading.value === 'Cell' || this.ulelementShading.value === 'Table') {
                    this.previewDivLeftDiagonal.classList.remove('e-de-table-border-inside-preview-click');
                    this.previewDivDiagonalRight.classList.remove('e-de-table-border-inside-preview-click');
                    this.previewDivBottomcenter.classList.add('e-de-table-border-inside-preview-click');
                    this.previewDivTopTop.classList.add('e-de-table-border-inside-preview-click');
                    this.previewDivTopBottom.classList.add('e-de-table-border-inside-preview-click');
                    this.previewDivBottomRight.classList.add('e-de-table-border-inside-preview-click');
                    this.previewDivBottomLeft.classList.add('e-de-table-border-inside-preview-click');
                    this.previewDivTopCenter.classList.add('e-de-table-border-inside-preview-click');
                    this.isShowHidePreviewTableElements('all');
                }
                else {
                    this.previewDivLeftDiagonal.classList.remove('e-de-table-border-inside-preview-click');
                    this.previewDivDiagonalRight.classList.remove('e-de-table-border-inside-preview-click');
                    this.previewDivBottomcenter.classList.remove('e-de-table-border-inside-preview-click');
                    this.previewDivTopTop.classList.add('e-de-table-border-inside-preview-click');
                    this.previewDivTopBottom.classList.add('e-de-table-border-inside-preview-click');
                    this.previewDivBottomRight.classList.add('e-de-table-border-inside-preview-click');
                    this.previewDivBottomLeft.classList.add('e-de-table-border-inside-preview-click');
                    this.previewDivTopCenter.classList.remove('e-de-table-border-inside-preview-click');
                    this.isShowHidePreviewTableElements('all');
                }
                break;
        }
    };
    BordersAndShadingDialog.prototype.isShowHidePreviewTableElements = function (settingDiv) {
        switch (settingDiv) {
            case 'none':
                this.previewDiv.style.border = 'none';
                this.previewRightDiagonalDiv.style.display = 'none';
                this.previewLeftDiagonalDiv.style.display = 'none';
                this.previewHorizontalDiv.style.display = 'none';
                this.previewVerticalDiv.style.display = 'none';
                break;
            case 'box':
                this.previewDiv.style.border = '1px solid rgba(0, 0, 0, .54)';
                this.previewRightDiagonalDiv.style.display = 'none';
                this.previewLeftDiagonalDiv.style.display = 'none';
                this.previewHorizontalDiv.style.display = 'none';
                this.previewVerticalDiv.style.display = 'none';
                break;
            case 'all':
                if (this.ulelementShading.value === 'Cell' || this.ulelementShading.value === 'Table') {
                    this.previewDiv.style.border = '1px solid rgba(0, 0, 0, .54)';
                    this.previewRightDiagonalDiv.style.display = 'none';
                    this.previewLeftDiagonalDiv.style.display = 'none';
                    this.previewHorizontalDiv.style.display = 'block';
                    this.previewVerticalDiv.style.display = 'block';
                }
                else {
                    this.previewDiv.style.border = '1px solid rgba(0, 0, 0, .54)';
                    this.previewRightDiagonalDiv.style.display = 'none';
                    this.previewLeftDiagonalDiv.style.display = 'none';
                    this.previewHorizontalDiv.style.display = 'none';
                    this.previewVerticalDiv.style.display = 'none';
                }
                break;
        }
    };
    BordersAndShadingDialog.prototype.handlePreviewCheckBoxShowHide = function (tableBorderDialogId, compareClass, element) {
        if (element.classList.contains(compareClass)) {
            element.classList.remove(compareClass);
        }
        else {
            element.classList.add(compareClass);
        }
    };
    BordersAndShadingDialog.prototype.showHidePreviewDivElements = function (tableBorderDialogId, compareClass, elementClass, compareElementClass, position) {
        var setElement = document.getElementById(tableBorderDialogId + elementClass);
        var compareElement = document.getElementById(tableBorderDialogId + compareElementClass);
        if (position === 'TopTop') {
            this.setPropertyPreviewDivElement(setElement, compareElement, compareClass, 'border-top');
        }
        else if (position === 'TopCenter') {
            this.setPropertyPreviewDivElement(setElement, compareElement, compareClass, 'display');
        }
        else if (position === 'TopBottom') {
            this.setPropertyPreviewDivElement(setElement, compareElement, compareClass, 'border-bottom');
        }
        else if (position === 'LeftDiagonal') {
            this.setPropertyPreviewDivElement(setElement, compareElement, compareClass, 'display');
        }
        else if (position === 'BottomLeft') {
            this.setPropertyPreviewDivElement(setElement, compareElement, compareClass, 'border-left');
        }
        else if (position === 'BottomCenter') {
            this.setPropertyPreviewDivElement(setElement, compareElement, compareClass, 'display');
        }
        else if (position === 'BottomRight') {
            this.setPropertyPreviewDivElement(setElement, compareElement, compareClass, 'border-right');
        }
        else if (position === 'RightDiagonal') {
            this.setPropertyPreviewDivElement(setElement, compareElement, compareClass, 'display');
        }
    };
    BordersAndShadingDialog.prototype.setPropertyPreviewDivElement = function (ele, compareElement, compareClass, property) {
        if (compareElement.classList.contains(compareClass) && property.split('-')[0] === 'border') {
            /* eslint-disable @typescript-eslint/no-explicit-any */
            ele.style["" + property] = '1px solid rgba(0, 0, 0, .54)';
        }
        else if (compareElement.classList.contains(compareClass) && property === 'display') {
            ele.style["" + property] = 'block';
        }
        else {
            ele.style["" + property] = 'none';
            /* eslint-enable @typescript-eslint/no-explicit-any */
        }
    };
    BordersAndShadingDialog.prototype.loadBordersShadingsPropertiesDialog = function (localeValue) {
        var lineStyle;
        var borderColor;
        var fillColor;
        var borderWidth;
        if (!isNullOrUndefined(this.documentHelper.selection.tableFormat.table)) {
            this.shadingContiner.style.display = 'block';
            this.ulelementShading.dataSource = [
                { Value: 'Cell', Name: localeValue.getConstant('Cell') },
                { Value: 'Table', Name: localeValue.getConstant('Table') },
                { Value: 'Paragraph', Name: localeValue.getConstant('Paragraph') }
            ];
            this.ulelementShading.dataBind();
            var tableFormat = this.documentHelper.selection.tableFormat.table.tableFormat;
            if (!isNullOrUndefined(tableFormat) && !isNullOrUndefined(tableFormat.borders)) {
                this.cloneBorders(tableFormat.borders);
                if (isNullOrUndefined(tableFormat.borders) || isNullOrUndefined(tableFormat.borders.top)) {
                    lineStyle = 1;
                    borderColor = '#000000';
                    borderWidth = 0;
                    fillColor = '#000000';
                }
                else {
                    lineStyle = this.getLineStyle(tableFormat.borders.top.lineStyle);
                    borderColor = tableFormat.borders.top.color;
                    borderWidth = tableFormat.borders.top.getLineWidth();
                    fillColor = tableFormat.shading.backgroundColor;
                }
                this.ulelementShading.value = 'Table';
                this.shadingColorPicker.value = fillColor;
                this.shadingColorPicker.disabled = false;
            }
        }
        else {
            this.shadingContiner.style.display = 'none';
            this.ulelementShading.dataSource = [
                { Value: 'Paragraph', Name: localeValue.getConstant('Paragraph') }
            ];
            this.ulelementShading.dataBind();
            var paraFormat = this.documentHelper.selection.start.paragraph.paragraphFormat;
            this.ulelementShading.value = 'Paragraph';
            this.cloneBorders(paraFormat.borders);
            var border = this.getSelectionBorderFormat();
            if (!border.hasValues()) {
                lineStyle = 1;
                borderColor = '#000000';
                borderWidth = 0.5;
            }
            else {
                lineStyle = this.getLineStyle(border.lineStyle);
                borderColor = border.color;
                borderWidth = border.lineWidth;
            }
            this.shadingColorPicker.disabled = true;
        }
        this.borderColorPicker.value = borderColor;
        this.previewDivLeftDiagonal.style.display = 'none';
        this.previewDivDiagonalRight.style.display = 'none';
        this.borderWidth.value = borderWidth;
        this.borderStyle.index = lineStyle;
    };
    BordersAndShadingDialog.prototype.getSelectionBorderFormat = function () {
        var border = new WBorder();
        var borders = this.documentHelper.selection.paragraphFormat.borders;
        if (borders.top.lineStyle !== "None") {
            return this.copyToBorder(border, borders.top);
        }
        else if (borders.left.lineStyle !== "None") {
            return this.copyToBorder(border, borders.left);
        }
        else if (borders.bottom.lineStyle !== "None") {
            return this.copyToBorder(border, borders.bottom);
        }
        else if (borders.right.lineStyle !== "None") {
            return this.copyToBorder(border, borders.right);
        }
        return border;
    };
    BordersAndShadingDialog.prototype.copyToBorder = function (border, selectionBorder) {
        if (!isNullOrUndefined(selectionBorder.lineStyle)) {
            border.lineStyle = selectionBorder.lineStyle;
        }
        if (!isNullOrUndefined(selectionBorder.color)) {
            border.color = selectionBorder.color;
        }
        if (!isNullOrUndefined(selectionBorder.lineWidth)) {
            border.lineWidth = selectionBorder.lineWidth;
        }
        return border;
    };
    /* eslint-disable  */
    BordersAndShadingDialog.prototype.cloneBorders = function (borders) {
        var topBorder = false;
        var bottomBorder = false;
        var leftBorder = false;
        var rightBorder = false;
        var horizontalBorder = false;
        var verticalBorder = false;
        var diagonalDownBorder = false;
        var customBorder = false;
        var diagonalUpBorder = false;
        if (borders !== null) {
            if (borders.top && (borders.top.hasNoneStyle || borders.top.lineStyle !== 'None')) {
                topBorder = true;
            }
            if (borders.bottom && (borders.bottom.hasNoneStyle || borders.bottom.lineStyle !== 'None')) {
                bottomBorder = true;
            }
            if (borders.left && (borders.left.hasNoneStyle || borders.left.lineStyle !== 'None')) {
                leftBorder = true;
            }
            if (borders.right && (borders.right.hasNoneStyle || borders.right.lineStyle !== 'None')) {
                rightBorder = true;
            }
            if (borders.horizontal && (borders.horizontal.hasNoneStyle || borders.horizontal.lineStyle !== 'None')) {
                horizontalBorder = true;
            }
            if (borders.vertical && (borders.vertical.hasNoneStyle || borders.vertical.lineStyle !== 'None')) {
                verticalBorder = true;
            }
            if (borders.diagonalDown && (borders.diagonalDown.hasNoneStyle || borders.diagonalDown.lineStyle !== 'None')) {
                diagonalDownBorder = true;
            }
            if (borders.diagonalUp && (borders.diagonalUp.hasNoneStyle || borders.diagonalUp.lineStyle !== 'None')) {
                diagonalUpBorder = true;
            }
            if (!(!topBorder || !bottomBorder || !leftBorder || !rightBorder)) {
                if (!(!topBorder || !bottomBorder || !leftBorder || !rightBorder || !horizontalBorder
                    || !verticalBorder || diagonalUpBorder || diagonalDownBorder)) {
                    if ((topBorder && bottomBorder && leftBorder && rightBorder && horizontalBorder && verticalBorder
                        && !diagonalUpBorder && !diagonalDownBorder)) {
                        if (borders.top.hasNoneStyle && borders.bottom.hasNoneStyle && borders.left.hasNoneStyle
                            && borders.right.hasNoneStyle && borders.horizontal.hasNoneStyle && borders.vertical.hasNoneStyle) {
                            this.setSettingPreviewDivElement('none');
                            this.customDiv.classList.remove('e-de-table-border-inside-setting-click');
                            this.noneDiv.classList.add('e-de-table-border-inside-setting-click');
                            this.boxDiv.classList.remove('e-de-table-border-inside-setting-click');
                            this.allDiv.classList.remove('e-de-table-border-inside-setting-click');
                        }
                        else {
                            this.setSettingPreviewDivElement('all');
                            this.allDiv.classList.add('e-de-table-border-inside-setting-click');
                            this.customDiv.classList.remove('e-de-table-border-inside-setting-click');
                            this.noneDiv.classList.remove('e-de-table-border-inside-setting-click');
                            this.boxDiv.classList.remove('e-de-table-border-inside-setting-click');
                        }
                    }
                }
                else if ((leftBorder && bottomBorder && topBorder && rightBorder && !horizontalBorder && !verticalBorder)) {
                    if (borders.top.hasNoneStyle && borders.bottom.hasNoneStyle && borders.left.hasNoneStyle
                        && borders.right.hasNoneStyle && borders.horizontal.hasNoneStyle && borders.vertical.hasNoneStyle) {
                        this.setSettingPreviewDivElement('none');
                        this.boxDiv.classList.remove('e-de-table-border-inside-setting-click');
                        this.allDiv.classList.remove('e-de-table-border-inside-setting-click');
                        this.customDiv.classList.remove('e-de-table-border-inside-setting-click');
                        this.noneDiv.classList.add('e-de-table-border-inside-setting-click');
                    }
                    else {
                        this.setSettingPreviewDivElement('box');
                        this.customDiv.classList.remove('e-de-table-border-inside-setting-click');
                        this.noneDiv.classList.remove('e-de-table-border-inside-setting-click');
                        this.boxDiv.classList.add('e-de-table-border-inside-setting-click');
                        this.allDiv.classList.remove('e-de-table-border-inside-setting-click');
                    }
                }
                else {
                    customBorder = true;
                }
            }
            else {
                customBorder = true;
            }
            this.previewDivLeftDiagonal.classList.remove('e-de-table-border-inside-preview-click');
            this.previewDivDiagonalRight.classList.remove('e-de-table-border-inside-preview-click');
            if (!topBorder && !bottomBorder && !leftBorder && !rightBorder && !horizontalBorder && !verticalBorder) {
                if (this.ulelementShading.value === 'Cell' || this.ulelementShading.value === 'Table') {
                    this.customDiv.classList.remove('e-de-table-border-inside-setting-click');
                    this.noneDiv.classList.add('e-de-table-border-inside-setting-click');
                    this.boxDiv.classList.remove('e-de-table-border-inside-setting-click');
                    this.allDiv.classList.remove('e-de-table-border-inside-setting-click');
                }
                else {
                    this.setSettingPreviewDivElement('none');
                    this.customDiv.classList.remove('e-de-table-border-inside-setting-click');
                    this.noneDiv.classList.add('e-de-table-border-inside-setting-click');
                    this.boxDiv.classList.remove('e-de-table-border-inside-setting-click');
                    this.allDiv.classList.remove('e-de-table-border-inside-setting-click');
                }
            }
            else if (customBorder) {
                this.customDiv.classList.add('e-de-table-border-inside-setting-click');
                this.noneDiv.classList.remove('e-de-table-border-inside-setting-click');
                this.boxDiv.classList.remove('e-de-table-border-inside-setting-click');
                this.allDiv.classList.remove('e-de-table-border-inside-setting-click');
                if (this.ulelementShading.value === 'Cell' || this.ulelementShading.value === 'Table') {
                    if (topBorder) {
                        this.previewDivTopTop.classList.add('e-de-table-border-inside-preview-click');
                    }
                    else {
                        this.previewDivTopTop.classList.remove('e-de-table-border-inside-preview-click');
                    }
                }
                else {
                    if (topBorder) {
                        this.previewDivTopTop.classList.add('e-de-table-border-inside-preview-click');
                        this.previewDiv.style.borderTop = '1px solid rgba(0,0,0,.54)';
                    }
                    else {
                        this.previewDivTopTop.classList.remove('e-de-table-border-inside-preview-click');
                        this.previewDiv.style.borderTop = '0px';
                    }
                }
                if (this.ulelementShading.value == 'Cell' || this.ulelementShading.value === 'Table') {
                    if (bottomBorder) {
                        this.previewDivTopBottom.classList.add('e-de-table-border-inside-preview-click');
                    }
                    else {
                        this.previewDivTopBottom.classList.remove('e-de-table-border-inside-preview-click');
                    }
                }
                else {
                    if (bottomBorder) {
                        this.previewDivTopBottom.classList.add('e-de-table-border-inside-preview-click');
                        this.previewDiv.style.borderBottom = '1px solid rgba(0,0,0,.54)';
                    }
                    else {
                        this.previewDivTopBottom.classList.remove('e-de-table-border-inside-preview-click');
                        this.previewDiv.style.borderBottom = '0px';
                    }
                }
                if (this.ulelementShading.value == 'Cell' || this.ulelementShading.value === 'Table') {
                    if (leftBorder) {
                        this.previewDivBottomLeft.classList.add('e-de-table-border-inside-preview-click');
                    }
                    else {
                        this.previewDivBottomLeft.classList.remove('e-de-table-border-inside-preview-click');
                    }
                }
                else {
                    if (leftBorder) {
                        this.previewDivBottomLeft.classList.add('e-de-table-border-inside-preview-click');
                        this.previewDiv.style.borderLeft = '1px solid rgba(0,0,0,.54)';
                    }
                    else {
                        this.previewDivBottomLeft.classList.remove('e-de-table-border-inside-preview-click');
                        this.previewDiv.style.borderLeft = '0px';
                    }
                }
                if (this.ulelementShading.value == 'Cell' || this.ulelementShading.value === 'Table') {
                    if (rightBorder) {
                        this.previewDivBottomRight.classList.add('e-de-table-border-inside-preview-click');
                    }
                    else {
                        this.previewDivBottomRight.classList.remove('e-de-table-border-inside-preview-click');
                    }
                }
                else {
                    if (rightBorder) {
                        this.previewDivBottomRight.classList.add('e-de-table-border-inside-preview-click');
                        this.previewDiv.style.borderRight = '1px solid rgba(0,0,0,.54)';
                    }
                    else {
                        this.previewDivBottomRight.classList.remove('e-de-table-border-inside-preview-click');
                        this.previewDiv.style.borderRight = '0px';
                    }
                }
                if (verticalBorder) {
                    this.previewDivBottomcenter.classList.add('e-de-table-border-inside-preview-click');
                }
                else {
                    this.previewDivBottomcenter.classList.remove('e-de-table-border-inside-preview-click');
                }
                if (horizontalBorder) {
                    this.previewDivTopCenter.classList.add('e-de-table-border-inside-preview-click');
                }
                else {
                    this.previewDivTopCenter.classList.remove('e-de-table-border-inside-preview-click');
                }
            }
        }
    };
    BordersAndShadingDialog.prototype.getLineStyle = function (lineStyle) {
        switch (lineStyle) {
            case 'Single': return 1;
            case 'Dot': return 2;
            case 'DashSmallGap': return 3;
            case 'DashLargeGap': return 4;
            case 'DashDot': return 5;
            case 'DashDotDot': return 6;
            case 'Double': return 7;
            case 'Triple': return 8;
            case 'ThinThickSmallGap': return 9;
            case 'ThickThinSmallGap': return 10;
            case 'ThinThickThinSmallGap': return 11;
            case 'ThinThickMediumGap': return 12;
            case 'ThickThinMediumGap': return 13;
            case 'ThinThickThinMediumGap': return 14;
            case 'ThinThickLargeGap': return 15;
            case 'ThickThinLargeGap': return 16;
            case 'ThinThickThinLargeGap': return 17;
            case 'SingleWavy': return 18;
            case 'DoubleWavy': return 19;
            case 'DashDotStroked': return 20;
            case 'Emboss3D': return 21;
            case 'Engrave3D': return 22;
            case 'Outset': return 23;
            case 'Inset': return 24;
            case 'Thick': return 25;
        }
        return 0;
    };
    /**
     * @private
     * @returns {void}
     */
    BordersAndShadingDialog.prototype.destroy = function () {
        if (!isNullOrUndefined(this.target)) {
            if (this.target.parentElement) {
                this.target.parentElement.removeChild(this.target);
            }
            for (var k = 0; k < this.target.childNodes.length; k++) {
                this.target.removeChild(this.target.childNodes[k]);
                k--;
            }
            this.target = undefined;
        }
        if (this.cellFormat) {
            this.cellFormat.destroy();
            this.cellFormat = undefined;
        }
        if (this.tableFormat) {
            this.tableFormat.destroy();
            this.tableFormat = undefined;
        }
        if (this.paragraphFormat) {
            this.paragraphFormat.destroy();
            this.paragraphFormat = undefined;
        }
        this.dialog = undefined;
        this.target = undefined;
        if (!isNullOrUndefined(this.borderStyle)) {
            this.borderStyle.destroy();
        }
        this.borderStyle = undefined;
        if (!isNullOrUndefined(this.borderColorPicker)) {
            this.borderColorPicker.destroy();
        }
        this.borderColorPicker = undefined;
        if (!isNullOrUndefined(this.shadingColorPicker)) {
            this.shadingColorPicker.destroy();
        }
        this.shadingColorPicker = undefined;
        if (!isNullOrUndefined(this.ulelementShading)) {
            this.ulelementShading.destroy();
        }
        this.ulelementShading = undefined;
        this.noneDivTransparent = undefined;
        this.boxDivTransparent = undefined;
        this.allDivTransparent = undefined;
        this.customDivTransparent = undefined;
        this.previewDiv = undefined;
        this.previewRightDiagonalDiv = undefined;
        this.previewLeftDiagonalDiv = undefined;
        this.previewVerticalDiv = undefined;
        this.previewHorizontalDiv = undefined;
        this.previewDivTopTopContainer = undefined;
        this.previewDivTopTop = undefined;
        this.previewDivTopCenterContainer = undefined;
        this.previewDivTopCenter = undefined;
        this.previewDivTopBottomContainer = undefined;
        this.previewDivTopBottom = undefined;
        this.previewDivLeftDiagonalContainer = undefined;
        this.previewDivLeftDiagonal = undefined;
        this.previewDivBottomLeftContainer = undefined;
        this.previewDivBottomLeft = undefined;
        this.previewDivBottomcenterContainer = undefined;
        this.previewDivBottomcenter = undefined;
        this.previewDivBottomRightContainer = undefined;
        this.previewDivBottomRight = undefined;
        this.previewDivDiagonalRightContainer = undefined;
        this.previewDivDiagonalRight = undefined;
        this.previewDivTopTopTransParent = undefined;
        this.previewDivTopCenterTransParent = undefined;
        this.previewDivTopBottomTransParent = undefined;
        this.previewDivLeftDiagonalTransParent = undefined;
        this.previewDivBottomLeftTransparent = undefined;
        this.previewDivBottomcenterTransparent = undefined;
        this.previewDivBottomRightTransparent = undefined;
        this.previewDivDiagonalRightTransparent = undefined;
        this.shadingContiner = undefined;
        this.noneDiv = undefined;
        this.customDiv = undefined;
        this.allDiv = undefined;
        this.boxDiv = undefined;
        this.documentHelper = undefined;
    };
    return BordersAndShadingDialog;
}());
export { BordersAndShadingDialog };
